export const SET_ADVISER_DETAILS = "SET_ADVISER_DETAILS";
export const SET_ADVISER_LOCATION = "SET_ADVISER_LOCATION";

export function setAdviserDetails(details) {
    return {
        type: SET_ADVISER_DETAILS,
        details
    };
}

export function setAdviserLocation(location) {
    return {
        type: SET_ADVISER_LOCATION,
        location
    };
}
